import React, { useEffect, useState } from "react";
import clsx from "clsx";

import ComponentStyles from "../styles/components.module.css";
import { ISizeValue, TSize } from "../resources/types";
import { sizeValues } from "../utilities";

interface ILoaderProps {
    size?: TSize;
    message?: string;
    fullscreen?: boolean;
    displayNewLoader?: boolean;
    logoLoader?: boolean;
    classes?: string;
    messageClasses?: string;
}

function Loader({
    size = "xs",
    message,
    fullscreen = false,
    displayNewLoader = false,
    logoLoader = false,
    classes,
    messageClasses,
}: ILoaderProps): JSX.Element {
    const [sizes, setSizes] = useState<ISizeValue>(sizeValues(size));

    useEffect(() => {
        if (fullscreen) {
            setSizes(sizeValues("md"));
        }
    }, [fullscreen])

    if (logoLoader) {
        return (
            <div className={clsx("text-center", classes,
                fullscreen && "h-screen flex flex-col justify-center")
            }>
                <div className="flex justify-center">
                    <div className={clsx("border-t-primary-border border-white !border-t-4 rounded-[50%] p-4 mx-2", ComponentStyles.loader)}>
                        <img
                            src="/img/korabia-icon.png"
                            className={clsx(
                                " ",
                                `${sizes.height} ${sizes.width}`,
                            )}
                        />
                    </div>

                </div>
                {message && <div className={clsx("text-sm text-gray-500 dark:text-text-dark-secondary mt-2", messageClasses)}>{message}</div>}
            </div>
        )
    }

    if (displayNewLoader)
        return (
            <div className="flex flex-col items-center">
                <div className="rounded-full w-14 h-14 flex justify-center items-center bg-primary-main">

                </div>
                <div className="bg-[#D9D9D9] dark:bg-primary-dark-surface h-[6px] w-24 mb-6 mt-0"></div>
                {message && <div className={clsx("text-md text-[#263238] dark:text-text-dark-primary", messageClasses)}>{message}</div>}
            </div>
        );

    return (
        <div className={clsx("text-center",
            fullscreen && "h-screen flex flex-col justify-center")
        }>
            <div className="flex justify-center">
                <div
                    className={clsx(
                        "border-t-primary-border border-2 mx-2 mb-2 rounded-[50%]",
                        `${sizes.height} ${sizes.width}`,
                        ComponentStyles.loader
                    )}
                />
            </div>
            {message && <div className={clsx("text-sm text-gray-500 dark:text-text-dark-secondary", messageClasses)}>{message}</div>}
        </div>
    );
}

export default Loader;